export default __webpack_public_path__ + "static/kb_pl-8095ab30ac2d3ec496376f44b7364179.jpg";